import type RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import type { HierarchyRetentionPolicyTag } from './createHierarchialSubMenuDeleteItem';

export default function buildHierarchyPolicyTags(
    retentionPolicyTagList: RetentionPolicyTag[]
): HierarchyRetentionPolicyTag[] {
    const hierarchyIndex = {};
    // RetentionId is the label Guid
    // Parent Label Identity is the parent retention id
    // Add root tags.
    const hierarchyPolicyTags = retentionPolicyTagList
        .filter(
            (tag: RetentionPolicyTag) =>
                tag.ParentLabelIdentity == null || tag.ParentLabelIdentity.length <= 0
        )
        .reduce((acc: HierarchyRetentionPolicyTag[], tag: RetentionPolicyTag) => {
            const hierarchyTag = { parentPolicyTag: tag, childrenPolicyTags: [] };
            acc.push(hierarchyTag);
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (22,13): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            // @ts-expect-error
            hierarchyIndex[tag.RetentionId] = hierarchyTag;
            return acc;
        }, []);

    // Add children tags
    retentionPolicyTagList
        .filter(
            (tag: RetentionPolicyTag) =>
                tag.ParentLabelIdentity != null &&
                tag.ParentLabelIdentity.length > 0 &&
                tag.ParentLabelIdentity in hierarchyIndex
        )
        .forEach((tag: RetentionPolicyTag) => {
            // Update the children policy tags of the hierarchy tag
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2538 (39,49): Type 'undefined' cannot be used as an index type.
            // @ts-expect-error
            const hierarchyTag = hierarchyIndex[tag.ParentLabelIdentity];
            hierarchyTag.childrenPolicyTags.push(tag);
        });
    return hierarchyPolicyTags;
}
